/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IHeiKlaviyoSignupFormData } from './hei-klaviyo-signup-form.data';
import { IHeiKlaviyoSignupFormProps } from './hei-klaviyo-signup-form.props.autogenerated';

export interface IHeiKlaviyoSignupFormViewProps extends IHeiKlaviyoSignupFormProps<IHeiKlaviyoSignupFormData> {}

/**
 *
 * HeiKlaviyoSignupForm component
 * @extends {React.PureComponent<IHeiKlaviyoSignupFormProps<IHeiKlaviyoSignupFormData>>}
 */
class HeiKlaviyoSignupForm extends React.PureComponent<IHeiKlaviyoSignupFormProps<IHeiKlaviyoSignupFormData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default HeiKlaviyoSignupForm;
